import React from 'react';
import { BLOCKS, INLINES } from "@contentful/rich-text-types";

// Utils //
import rawToReact from "../../../utils/rawToReact";

// Styles //
import "./checkboxText.scss";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

interface CheckboxTextProps {
    setInputValue: (nombreId, value, type) => void;
    nombreId: string;
    type: string;
    description: any;
    icon: string;
    iconDark?: string;
    onToggle: () => void;
    active?: boolean;
    checked?: boolean;
    title: string;
}

const CheckboxText = (props: CheckboxTextProps) => {
    const {nombreId, type, checked, description, icon, iconDark, active, title, setInputValue, onToggle} = props;


    return (
        <div className={`a-checkbox-text ${active ? "opened" : ""}`}>
            <div className="a-checkbox-text__header">
                <label htmlFor={nombreId}>
                    <input 
                        type="checkbox" 
                        id={nombreId} 
                        checked={checked} 
                        onChange={(e) =>
                            setInputValue(
                                nombreId,
                                e.target.checked,
                                type
                            )
                        }/>
                    {icon && (
                        <img src={icon} alt={nombreId} className="a-checkbox-text__header__icon--light" />
                    )}
                    {iconDark && (
                        <img src={iconDark} alt={nombreId} className="a-checkbox-text__header__icon--dark" />
                    )}
                    <span>{title}</span>
                </label>
                <i className="a-input__form_iconArrow icon-chevron-down1" onClick={onToggle}/>
            </div>
            <div className="a-checkbox-text__body">
                {description && rawToReact(
                    description.raw,
                    contentfulRenderOptions
                )}
            </div>
        </div>
    )
}

export default CheckboxText